export default "__VITE_ASSET__bzs_u50d__"